<template>
  <transition name="tutorial">
    <div class="bl_modalBlock">
      <div class="bl_modalContent">

        <div class="bl_modalHeader">
          <!-- eslint-disable-next-line -->
          <ruby>遊<rp>(</rp><rt>あそ</rt><rp>)</rp></ruby>び<ruby>方<rp>(</rp><rt>かた</rt><rp>)</rp></ruby>
        </div>

        <div id="tutorial">
          <div class="bl_quizTutorialBlock">
            <div class="bl_tutorialBody_img">
              <img class="pcBlock" src="/kids/quiz/static/image/tutorial_img_01.png" alt="">
              <img class="spBlock" src="/kids/quiz/static/image/sp/tutorial_img_01.png" alt="">
            </div>
            <!-- eslint-disable-next-line -->
            <p class="bl_tutorialBody_txt"><ruby>問題<rp>(</rp><rt>もんだい</rt><rp>)</rp></ruby>を<ruby>読<rp>(</rp><rt>よ</rt><rp>)</rp></ruby>んで3つの<ruby>答<rp>(</rp><rt>こた</rt><rp>)</rp></ruby>えから1つをえらんでね</p>
          </div>
          <hr class="spBlock">
          <div class="bl_quizTutorialBlock">
            <div class="bl_tutorialBody_img">
              <img class="pcBlock" src="/kids/quiz/static/image/tutorial_img_02.png" alt="">
              <img class="spBlock" src="/kids/quiz/static/image/sp/tutorial_img_02.png" alt="">
            </div>
            <!-- eslint-disable-next-line -->
            <p class="bl_tutorialBody_txt"><ruby>答<rp>(</rp><rt>こた</rt><rp>)</rp></ruby>えをえらんだら、「<ruby>答<rp>(</rp><rt>こた</rt><rp>)</rp></ruby>え<ruby>合<rp>(</rp><rt>あ</rt><rp>)</rp></ruby>わせ」ボタンをおしてね</p>
          </div>
        </div>

        <div class="bl_btnBlock">
          <a class="el_btn" @click="close()">OK</a>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Tutorial',
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.bl_modalBlock {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  transition: opacity 2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: scroll;
}

.bl_modalContent {
  width: 80%;
  padding: 20px 30px 32px;
  background-color: #fff;
  border-radius: 10px;
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.bl_modalHeader{
  text-align: center;
  font-size: 36px;
  font-weight: bold;
}

#tutorial{
  display: flex;
  justify-content: center;
  align-items: baseline;
  margin-bottom: 58px;

  .bl_quizTutorialBlock{
    width: 100%;
    padding: 0 10px;

    &:last-of-type{
      margin-right: 0;
    }

    .bl_tutorialBody_img{
      width: 100%;
      margin-bottom: 25px;
    }

    .bl_tutorialBody_txt{
      font-size: 18px;
      line-height: 32px;
    }
  }

  hr{
    background-color: #f0f0f0;
    width: 100%;
  }
}

.bl_btnBlock{
  .el_btn{
    margin: 0 auto;
    max-width: 325px;
  }
}

@media screen and (max-width: 768px){
  .bl_modalHeader{
    font-size: 22px;
  }

  #tutorial{
    display: block;
    margin-bottom: 0;

    .bl_quizTutorialBlock{
      margin-right: 0;

      .bl_tutorialBody_img{
        max-width: none;
        margin-bottom: 5px;
      }

      .bl_tutorialBody_txt{
        max-width: none;
        font-size: 14px;
      }
    }
  }

  hr{
    margin: 15px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tutorial.vue